export function getLinkPopUrl(value?: string): string | null {
  const url = value?.trim()

  if (
    !url ||
    !/^https?:\/\/[^/?#]/i.test(url) ||
    /[\s\\]/.test(url) ||
    Array.from(url).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
  )
    return null

  const authority = url.split('://')[1].split(/[/?#]/)[0]

  if (/[@%<>^|{}]/.test(authority)) return null

  try {
    const parsed = new URL(url)

    if (!parsed.hostname || parsed.username || parsed.password) return null

    return url
  } catch {
    return null
  }
}

export function openLinkPopUrl(value?: string): boolean {
  const url = getLinkPopUrl(value)

  if (!url) return false

  const openedWindow = window.open('', '_blank')

  if (!openedWindow) return false

  try {
    openedWindow.opener = null
    openedWindow.location.replace(url)
    return true
  } catch {
    openedWindow.close()
    return false
  }
}
